export const CAMPAIGN_PAUSED_STATUSES = [
  'UserPaused',
  'BudgetPaused',
  'BudgetUserPaused',
];

export const CAMPAIGN_TYPE_DISPLAY = _TL_('Display');
export const CAMPAIGN_TYPE_NATIVE = _TL_('Native');
export const CAMPAIGN_TYPE_ONLINE_VIDEO = _TL_('Online video');
export const CAMPAIGN_TYPE_FEED_BASED = _TL_('Feed-based');

export const DEFAULT_CAMPAIGN_SUBTYPE_FILTER = "CampaignSubType in ['AudienceDynamicFeedBased', 'AudienceFeedBased', 'AudienceStatic', 'AudienceVideoAds', 'BrandAwarenessVideoAds', 'DisplayAds']";
